<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('common.source')"
    class="manifest-source-filter w-2"
    optional
  >
    <RygenMultiSelect
      :id="inputId"
      v-model="internalValue.source"
      :options="sourceOptions"
      option-label="label"
      option-value="value"
      :placeholder="t('common.source')"
      display="chip"
      append-to="body"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { mapEnumToTranslatedDropdownValues } from '@rygen/rygen-ui/i18n';

import { ManifestSearchCriteria, ManifestSource } from '@/model';

import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import RygenMultiSelect from '@rygen/rygen-ui/components/form/RygenMultiSelect.vue';

const internalValue = defineModel({
  type: Object as PropType<ManifestSearchCriteria>,
  required: true,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);

const { t } = useI18n();

const sourceOptions = mapEnumToTranslatedDropdownValues(
  ManifestSource,
  'ManifestSource',
);
</script>
